import { ReactTheme } from './Theme.types'

export const SYSTEM_THEME: ReactTheme = {
  primary: '#1d2b3a',
  primaryForeground: '#ffffff',
  pagePadding: '#ffffff',
  windowPadding: '#ffffff',
  windowStrong: '#c3cad3',
  windowBackground: '#f3f5f8',
  foreground: '#1b1f24',
  headingStart: '#1b1f24',
  headingEnd: '#1b1f24',
  uiBackground: '#ffffff',
  uiForeground: '#4a5260',
  uiSelection: '#1d2b3a',
  uiSelectionHighlight: '#0f1a26',
  uiSelectionForeground: '#ffffff',
  uiBorder: '#c3cad3',
  higlightBackground: '#eef2f6',
  bar: '#1d2b3a',
  barForeground: '#ffffff',
  barMuted: '#c9d3de',
  accent: '#1f5bd8',
  quiet: '#8a94a3',
}

export const MOBILE_SIZE = 768
